// ** React Imports
import { memo, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";

// ** Redux
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";

// ** Header Components
import MessagesButton from "./Messages/MessagesButton";
import NotificationsButton from "./Notifications/NotificationsButton";
import UserMenu from "./UserMenu/UserMenu";
import DropdownSearch from "./Search";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";
import authContext from "contexts/authContext";

// ** Styled Components
import { StyledLoginHeaderButton } from "../styles/LoginHeaderButton.styled";

// #####################################################

const RightButtonsSection = ({ userId, userFrozen, locationPathname }) => {
	const { t } = useTranslation(["common", "pages", "landing"]);

	const isAuth = useContext(authContext);

	const { isDesktop } = useContext(deviceTypeContext);

	const messagesCount = useSelector(
		(state) => state.global.statisticsSelf.messages
	);
	const notificationsCount = useSelector(
		(state) => state.global.statisticsSelf.notifications
	);

	const history = useHistory();

	const hideLoginButtonOnPages =
		locationPathname?.match(/registration/)?.length;

	const sectionContent = useMemo(() => {
		if (userId) {
			return (
				<>
					{isDesktop && (
						<Block flex justifyCenter>
							<DropdownSearch />
						</Block>
					)}

					<Block flex justifyCenter>
						<MessagesButton
							isUserFrozen={userFrozen}
							messagesCount={messagesCount}
							locationPathname={locationPathname}
						/>
					</Block>

					<Block flex justifyCenter>
						<NotificationsButton
							isUserFrozen={userFrozen}
							notificationsCount={notificationsCount}
							locationPathname={locationPathname}
						/>
					</Block>

					<Block flex justifyCenter>
						<UserMenu />
					</Block>
				</>
			);
		}
		return null;
	}, [
		userId,
		isDesktop,
		userFrozen,
		messagesCount,
		notificationsCount,
		locationPathname,
	]);

	// #####################################################;

	return isAuth ? (
		isDesktop ? (
			<Block flex style={{ gap: "1rem" }}>
				{sectionContent}
			</Block>
		) : (
			sectionContent
		)
	) : (
		!hideLoginButtonOnPages && (
			<div
				style={{
					gridColumn: "4 / span 2",
					justifySelf: "flex-end",
				}}
			>
				<Block flex alignCenter mr={2} style={{ gap: "1rem" }}>
					{isDesktop && <DropdownSearch />}
					<StyledLoginHeaderButton
						onClick={() => {
							history.push("/");
							window.scrollTo(0, 0);
						}}
					>
						{t("landing:login.action")}
					</StyledLoginHeaderButton>
				</Block>
			</div>
		)
	);
};

// #####################################################

export default memo(RightButtonsSection, (prevProps, nextProps) => {
	return (
		prevProps.userId === nextProps.userId &&
		prevProps.userFrozen === nextProps.userFrozen &&
		prevProps.messagesCount === nextProps.messagesCount &&
		prevProps.notificationsCount === nextProps.notificationsCount &&
		prevProps.locationPathname === nextProps.locationPathname
	);
});

// #####################################################
